import { render, staticRenderFns } from "./VatsTab.vue?vue&type=template&id=d9c6d23a&"
import script from "./VatsTab.vue?vue&type=script&lang=ts&"
export * from "./VatsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports